import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router, RouterOutlet } from '@angular/router';
import { CvatProjectsService } from '../../../../services/cvat-projects.service';
import { CommonModule, Location } from '@angular/common';
import { filter, map, Observable, Subscription, tap } from 'rxjs';
import { DataTableComponent } from '../../../shared/data-table/data-table.component';
import { MainHeaderComponent } from "../../../shared/main-header/main-header.component";
import { MatButtonModule } from '@angular/material/button';
import { CvatProjects } from '../../../../models/cvat-projects';
import { MatDrawerContainer, MatDrawerContent, MatDrawer } from '@angular/material/sidenav';
import { ListLibraryObjectsComponent } from '../../../library-objects/list-library-objects/list-library-objects.component';
import { MatSpinner } from '@angular/material/progress-spinner';
import { CvatTasksComponent } from '../../cvat-tasks/cvat-tasks.component';
import { CvatTasksService } from '../../../../services/cvat-tasks.service';
import { TableCustomFilterComponent } from '../../../shared/table-custom-filter/table-custom-filter.component';
// import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';
import { FilterMetadata } from 'primeng/api';
import { MatIconModule } from '@angular/material/icon';
import { SidenavLibraryObjectsComponent } from '../../../sidenav-library-objects/sidenav-library-objects.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmMessageComponent } from '../../../shared/dialog-confirm-message/dialog-confirm-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MenuToggleComponent } from '../../../shared/menu-toggle/menu-toggle.component';


@Component({
  selector: 'app-project-details-cvat',
  standalone: true,
  imports: [RouterOutlet, CommonModule, TableCustomFilterComponent, DataTableComponent, MainHeaderComponent, MatButtonModule, MatDrawerContainer, MatDrawerContent, SidenavLibraryObjectsComponent, MatDrawer, MatSpinner, CvatTasksComponent, MatIconModule, MenuToggleComponent],
  templateUrl: './project-details-cvat.component.html',
  styleUrl: './project-details-cvat.component.scss'
})
export class ProjectDetailsCvatComponent {
  searchTerm = '';
  isDisabled: boolean = false
  project_id!: number;
  data: any[] = [];
  columns: any[] = [];
  totalRecords = 0;
  rows = 5;
  first = 0;
  globalFilterFields: string[] = [];
  selectedItems: any[] = [];
  projectDetails!: CvatProjects | undefined;
  project_name = '';
  isLoaderActive = true;


  @ViewChild('childOutlet', { read: RouterOutlet }) outlet!: RouterOutlet;
  @ViewChild('drawer') drawer!: MatDrawer;

  constructor(private router: Router, private route: ActivatedRoute, private projectService: CvatProjectsService, private tasksService: CvatTasksService, private location: Location, private dialog: MatDialog, private _snackBar: MatSnackBar) { }


  ngOnInit() {
    console.log('🔍 Componente padre inicializado');
    this.router.navigate(['tasks'], { relativeTo: this.route });
    this.project_id = +this.route.snapshot.paramMap.get('project_id')!;
    this.projectService.loadProjectDetails(this.project_id).subscribe(data => {
      this.projectDetails = data;
      this.project_name = data.name
      console.log('Details', this.projectDetails)
    })
    console.log('ID', this.project_id);

    this.loadLabelsLazy({
      first: this.first,
      rows: this.rows,
      globalFilter: '',
      sortField: '',
      sortOrder: 1
    });
  }


  loadLabelsLazy(event: any) {
    console.log('Lazy load event:', event);


    if (event.globalFilter !== undefined) {
      this.searchTerm = event.globalFilter;
    }

    const page = Math.floor(event.first / event.rows) + 1;
    const filterLogic = this.buildJsonLogicFilter(event.filters);
    const params = {
      page,
      page_size: event.rows,
      ...(event.globalFilter && { search: event.globalFilter }),
      ...(event.sortField && {
        sort: (event.sortOrder === 1 ? '' : '-') + event.sortField
      }),
      project_id: this.project_id,
      filter: JSON.stringify(filterLogic),
    };

    console.log('FILTRO', params.filter)

    this.projectService.loadLabels(this.project_id!, params).pipe(
      map(({ results, count }) => {
        const attributeSet = new Set<string>();

        const data = results.map(label => {
          const flat = Object.fromEntries(
            (label.attributes || []).map((a: any) => {
              attributeSet.add(a.name);
              return [a.name, a.values ?? ''];
            })
          );

          return { ...label, ...flat };
        });
        console.log('DATA LABELS', data)

        if (this.columns.length === 0) {
          const attrs = Array.from(attributeSet);
          this.columns = [
            { field: 'name', header: 'Nombre', filter: true, orderby: true },
            ...attrs.map(attr => ({
              field: attr,
              header: this.capitalize(attr),
              filter: false,
              orderby: false
            }))
          ];
          this.globalFilterFields = ['name', ...attrs];
        }
        this.data = data;
        this.totalRecords = count;
        console.log('Total Records:', this.totalRecords);
      })
    ).subscribe(
      // {
      //   next: () => this.isLoaderActive = false,  // Desactiva loader
      //   error: () => this.isLoaderActive = false
      // }
    );
  }

  goback(): void {
    this.location.back()
  }

  capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }


  onSelectionChange(event: any) {
    console.log('event', event)
    this.selectedItems = event
  }
  onRowSelect(event: any) {
    console.log('evento', event)
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  buildJsonLogicFilter(filters: { [s: string]: FilterMetadata[] | FilterMetadata }): any {
    const logic = { and: [] as any[] };

    for (const field in filters) {
      const filterMeta = filters[field];

      const getLogicExpression = (op: string, field: string, value: string) => {
        switch (op) {
          case 'contains':
            return { includes: [{ var: field }, value] };
          case 'startsWith':
            return { startsWith: [{ var: field }, value] };
          case 'equals':
          default:
            return { '==': [{ var: field }, value] };
        }
      };

      if (Array.isArray(filterMeta) && filterMeta.length > 0) {
        const meta = filterMeta[0];
        if (meta.value != null && meta.value !== '') {
          const op = meta.matchMode || 'equals'; // usar equals por defecto
          logic.and.push(getLogicExpression(op, field, meta.value));
        }
      } else if ((filterMeta as any).value != null && (filterMeta as any).value !== '') {
        const meta = filterMeta as any;
        const op = meta.matchMode || 'equals';
        logic.and.push(getLogicExpression(op, field, meta.value));
      }
    }

    return logic.and.length > 0 ? logic : {};
  }


  onDeleteLabels(labels: any[]) {
    const dialogRef = this.dialog.open(DialogConfirmMessageComponent, {
      data: {
        message: 'Se eliminarán las etiquetas seleccionadas'
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        labels.map(label => {
          this.projectService.deleteLabels(label.id).subscribe({
            next: () => {
              this._snackBar.open('Etiquetas Eliminadas correctamente', 'Ok')
              this.loadLabelsLazy({
                first: this.first,
                rows: this.rows,
                globalFilter: '',
                sortField: '',
                sortOrder: 1
              });
              this.selectedItems = []
            },
            error: (err) => {
              this._snackBar.open(`Error al eliminar etiquetas: ${err.error.message}`)
            }
          })
        })
      }
    })
  }

  onCloseSidenav() {
    console.log('Cerrando sidenav desde el padre');
    this.drawer.close();
  }

}
